/* eslint-disable max-len */
import Http from '../shared/http';

const http = Http.getHttp();

// action export constants
export const GET_PASSWORD_POLICY = 'GET_PASSWORD_POLICY';
export const GET_SECURITY_POLICY = 'GET_SECURITY_POLICY';
export const LOGIN_REJECTED = 'LOGIN_REJECTED';
export const GET_PASSWORD_POLICY_FULFILLED = 'GET_PASSWORD_POLICY_FULFILLED';
export const PASSWORD_POLICY_CLEAR = 'PASSWORD_POLICY_CLEAR';

// action creators
export const getSecurityPolicy = () => ({ type: GET_SECURITY_POLICY, payload: http.get('/security-policy') });
export const getPasswordAndGoToPage = (history: any, path: any) => {
  return async (dispatch: any) => {
    await dispatch(getSecurityPolicy());
    history.push(path);
  };
};
export const clearPasswordPolicy = () => ({ type: PASSWORD_POLICY_CLEAR });
